"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reporter = void 0;
var browser_1 = require("./browser");
var api_1 = require("./api");
var offline_1 = require("./browser/offline");
var uuid_1 = require("./utils/uuid");
var manifest_json_1 = __importDefault(require("./manifest.json"));
var log_1 = require("./utils/log");
var fingerprint_1 = require("./utils/fingerprint");
var syncSessionId = function () {
    window.__APMS_SESSION_ID__ = window.__APMS_SESSION_ID__ || (0, uuid_1.uuidv4)();
    window.__APMS_SESSION_START_TIME__ =
        window.__APMS_SESSION_START_TIME__ || new Date().toISOString();
    return [window.__APMS_SESSION_ID__, window.__APMS_SESSION_START_TIME__];
};
var Reporter = (function () {
    function Reporter(configs, network) {
        var _a;
        this.queue = [];
        this.customQueue = [];
        this.fingerprint = '';
        this.tags = {};
        this.session_id = '';
        this.session_start_time = '';
        this.timeOffset = 0;
        this.configs = configs;
        this.userAgent = new browser_1.UserAgent();
        this.network = network;
        this.fingerprint = configs.fingerprint || '';
        this.offlineStore = new offline_1.OfflineStore(configs.de_app_id, network);
        this.offlineStore.setup();
        _a = syncSessionId(), this.session_id = _a[0], this.session_start_time = _a[1];
    }
    Reporter.prototype.initFingerprint = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    this.fingerprint = (0, fingerprint_1.setFingerprint)();
                }
                catch (error) {
                    console.log('initFingerprint error', error);
                }
                return [2];
            });
        });
    };
    Reporter.prototype.serverNow = function (timestamp) {
        var _a;
        return ((typeof timestamp === 'number' ? timestamp : new Date().getTime()) +
            ((_a = this.timeOffset) !== null && _a !== void 0 ? _a : 0));
    };
    Reporter.prototype.register = function (plugin) {
        try {
            plugin.serverNow = this.serverNow.bind(this);
            if (plugin.delegateReporter) {
                plugin.reporter = this;
            }
            var triggerHandler = function () { return false; };
            plugin.register({
                trigger: triggerHandler,
                de_app_id: this.configs.de_app_id,
                env: this.configs.environment,
            });
        }
        catch (error) {
            log_1.Logger.log('Failed to register plugin');
            log_1.Logger.error(error);
        }
    };
    Reporter.prototype.unregister = function (plugin) {
        plugin.unregister(this.configs.de_app_id);
    };
    Object.defineProperty(Reporter.prototype, "app", {
        get: function () {
            var _a;
            return {
                region: (_a = this.configs.region) !== null && _a !== void 0 ? _a : 'unknown',
                type: 'web',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reporter.prototype, "commonData", {
        get: function () {
            var _a = this.configs, js_bundle_version = _a.js_bundle_version, js_bundle_name = _a.js_bundle_name, js_build_id = _a.js_build_id;
            return {
                isSampled: 0,
                app: this.app,
                commonInfo: this.commonInfo,
                device: this.device,
                eventType: 'web-performance',
                extra: {
                    webCommonData: {
                        js_bundle_name: js_bundle_name,
                        js_bundle_version: js_bundle_version || '',
                        js_build_id: js_build_id || '',
                        js_sdk_name: manifest_json_1.default.name,
                        js_sdk_version: manifest_json_1.default.version,
                        js_engine_name: this.userAgent.browser.engine_name,
                        js_engine_version: this.userAgent.browser.engine_version,
                        js_browser_name: this.userAgent.browser.browser_name,
                        js_browser_version: this.userAgent.browser.browser_version,
                    },
                },
                metaData: this.metaData,
                pageInfo: {
                    pageId: window.location.href,
                },
                session: {
                    id: this.session_id,
                    startedAt: this.session_start_time,
                },
                user: {
                    email: this.configs.user_email,
                    name: this.configs.user_name,
                    id: this.configs.user_id || '',
                },
                tag: 'web-performance',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reporter.prototype, "commonInfo", {
        get: function () {
            return {
                bundle_id: '',
                carrier_provider_code: '',
                carrier_provider_name: '',
                current_time: this.serverNow(),
                de_app_id: this.configs.de_app_id,
                device_id: this.fingerprint,
                is_vpn: false,
                local_wifi_ip: '',
                os_version: this.userAgent.device.os_version,
                screen_density: this.userAgent.screen.screen_dpr || 0,
                screen_height: this.userAgent.screen.screen_height || 0,
                screen_width: this.userAgent.screen.screen_width || 0,
                session_id: this.session_id,
                user_id: this.configs.user_id || '',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reporter.prototype, "device", {
        get: function () {
            var _a, _b;
            return {
                id: this.fingerprint,
                manufacturer: this.userAgent.browser.browser_name,
                model: this.userAgent.browser.browser_version,
                osName: (_a = this.userAgent.device.os_name) !== null && _a !== void 0 ? _a : 'unknown',
                osVersion: (_b = this.userAgent.device.os_version) !== null && _b !== void 0 ? _b : 'unknown',
                orientation: this.userAgent.screen.orientation,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reporter.prototype, "metaData", {
        get: function () {
            return {
                device: {
                    brand: this.userAgent.browser.browser_name,
                    screenDensity: this.userAgent.screen.screen_dpr,
                    screenResolution: this.userAgent.screen.screen_width + "x" + this.userAgent.screen.screen_height,
                    networkAccess: this.userAgent.connection.connection_type,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Reporter.prototype.sendData = function (data, pageUnload) {
        if (pageUnload === void 0) { pageUnload = false; }
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.network.sendRequest({
                                reportData: data,
                                pageUnload: pageUnload,
                            })];
                    case 1:
                        res = _a.sent();
                        if (res === api_1.REQUEST_FAILED) {
                            this.offlineStore.cacheData(data);
                        }
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.offlineStore.cacheData(data);
                        log_1.Logger.warn("[APMS] Failed to send data: " + ((error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || 'unknown reason.'));
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Reporter.prototype.sendBulkData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.network.sendBulk(data)];
                    case 1:
                        res = _a.sent();
                        return [2, res];
                    case 2:
                        error_2 = _a.sent();
                        this.offlineStore.cacheData(data);
                        log_1.Logger.warn("[APMS] Failed to send data bulk: " + ((error_2 === null || error_2 === void 0 ? void 0 : error_2.message) || 'unknown reason.'));
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    return Reporter;
}());
exports.Reporter = Reporter;
